import { render } from "./process.vue?vue&type=template&id=51de34c8&scoped=true"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"

import "./process.vue?vue&type=style&index=0&id=51de34c8&rel=stylesheet%2Fscss&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51de34c8"
/* hot reload */
if (module.hot) {
  script.__hmrId = "51de34c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51de34c8', script)) {
    api.reload('51de34c8', script)
  }
  
  module.hot.accept("./process.vue?vue&type=template&id=51de34c8&scoped=true", () => {
    api.rerender('51de34c8', render)
  })

}

script.__file = "src/views/static/process/process.vue"

export default script